var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.6159 25.499L30.2998 21.1575H26.0869V18.3356C26.0869 17.1485 26.6751 15.9885 28.5558 15.9885H30.4981V12.2915C29.367 12.1113 28.2241 12.0138 27.0786 11.9998C23.6112 11.9998 21.3475 14.0823 21.3475 17.8472V21.1575H17.5039V25.499H21.3475V35.9998H26.0869V25.499H29.6159Z","fill":"#337FFF"}));
}

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
